import { fields } from "@monorepo/utils/src/variables/projectsData/fundsReportsView/fields";

export const filtersElements = [
  {
    value: fields.FUND_PARENT_CODE,
    title: "Наименование архива",
    type: "autocomplete",
    showSelectedKey: "name",
    autocompleteActionName: "getAutocompleteByCode",
    width: 250,
  },
  {
    value: fields.FUND_DATE_FIRST_ARRIVAL,
    dateValues: [fields.FUND_DATE_FIRST_ARRIVAL_FROM, fields.FUND_DATE_FIRST_ARRIVAL_TO],
    title: "Начальная дата фонда",
    type: "datePeriod",
    width: 250,
  },
  {
    value: fields.FUND_DATE_LAST_ARRIVAL,
    dateValues: [fields.FUND_DATE_LAST_ARRIVAL_FROM, fields.FUND_DATE_LAST_ARRIVAL_TO],
    title: "Конечная дата фонда",
    type: "datePeriod",
    width: 250,
  },
  {
    value: fields.FUND_STATUS,
    title: "Состояние",
    type: "select",
    selectItemsField: "elementStatuses",
    width: 250,
  },
];
